<script setup lang="ts">
import { useImageSearch } from "@/features/search/store";
import { computed } from "vue";
import CustomButton from "@/components/UI/CustomButtom/CustomButton.vue";
import CustomSvgIcons from "@/components/HelpersComponents/CustomSvgIcons.vue";

import Button from "primevue/button";
import { useSharedStateForComponents } from "@/features/search/store";
import { useI18n } from "vue-i18n";

const imageSearch = useImageSearch();
const { t } = useI18n();
const { setStep1ForImageFlow, setStep2ForImageFlow } = useSharedStateForComponents();

const base64data = computed(() => imageSearch.imageBase64Data);
const emits = defineEmits(["showModal"]);

function clearImageSearch() {
  imageSearch.currentImageLink = "";
  imageSearch.imageBase64Data = undefined;
  imageSearch.imageFile = undefined;
}

function showModal() {
  if (imageSearch?.currentImageLink?.length > 0) {
    setStep2ForImageFlow();
  } else {
    setStep1ForImageFlow();
  }

  emits("showModal");
}
</script>

<template>
  <Button v-if="!base64data" severity="warn" rounded @click="showModal">
    <span class="mobile-search-add-photo-text button hide-on-mobile">{{
      t("home_page.add_photo")
    }}</span>
    <CustomSvgIcons name="scope" :size="16" color="var(--active-100)" />
  </Button>
  <div v-else class="uploaded-photo" @click="showModal">
    <img class="uploaded-image" :src="base64data" />
    <div class="clearImage" @click.stop="clearImageSearch">
      <i class="pi pi-trash" />
    </div>
  </div>
</template>

<style scoped>
.clearImage {
  display: none;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  top: 0;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 12px;
}

.uploaded-photo {
  position: relative;
  width: 48px;
  height: 48px;
}

.upload-photo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  padding: 12px;
  border-radius: 28px;
  background-color: rgba(162, 184, 233, 0.4);
  cursor: pointer;
}

.uploaded-photo:hover .clearImage {
  display: flex;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.2);
}

.mobile-search-add-photo-text {
  white-space: nowrap;
  color: var(--active-100);
}

@media (max-width: 1024px) {
  .hide-on-mobile {
    display: none;
  }
}
</style>
